module.exports = __webpack_public_path__ + "img/sample-03.fa2382af.jpg";